<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          Klienci na podstawie dat meldunków
        </div>
        <div class="card-body">
          <form action="/api/clients/exports/stay-period"
                target="_blank"
                @submit="validateForm($event)"
                method="GET">
            <div class="row">
              <div class="form-group col-md-4">
                <label for="dateFrom">
                  Data od
                </label>
                <input
                    class="form-control"
                    id="dateFrom"
                    name="dateFrom"
                    v-model="dateFrom"
                    v-bind:class="{ 'is-invalid': $v.dateFrom.$error }"
                    v-custom-validator="$v.dateFrom"
                    placeholder="RRRR-MM-DD"
                    type="text"/>
                <div class="invalid-feedback" v-if="!$v.dateFrom.required">
                  {{ $t('error.fieldRequired') }}
                </div>
                <div class="invalid-feedback" v-if="!$v.dateFrom.validDate">
                  {{ $t('error.dateInvalid') }}
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="dateTo">
                  Data do
                </label>
                <input
                    class="form-control"
                    id="dateTo"
                    name="dateTo"
                    v-bind:class="{ 'is-invalid': $v.dateTo.$error }"
                    v-custom-validator="$v.dateTo"
                    v-model="dateTo"
                    placeholder="RRRR-MM-DD"
                    type="text"/>
                <div class="invalid-feedback" v-if="!$v.dateTo.required">
                  {{ $t('error.fieldRequired') }}
                </div>
                <div class="invalid-feedback" v-if="!$v.dateTo.validDate">
                  {{ $t('error.dateInvalid') }}
                </div>
              </div>
            </div>
            <button class="btn btn-primary" type="submit">Pobierz</button>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          Karty lojalnościowe do wydania
        </div>
        <div class="card-body">
          <a class="btn btn-primary" href="/api/clients/exports/applicable-loyalty-cards" target="_blank">Pobierz</a>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          Klienci z podziałem na karty lojalnościowe
        </div>
        <div class="card-body">
          <a class="btn btn-primary" href="/api/clients/exports/clients-by-card" target="_blank">Pobierz</a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import { required } from 'vuelidate/lib/validators';
  import moment from 'moment';

  const validDate = value => moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD') === value;

  export default {
    data: function () {
      return {
        dateFrom: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
      };
    },
    validations: {
      dateFrom: {
        required,
        validDate,
      },
      dateTo: {
        required,
        validDate,
      },
    },
    methods: {
      validateForm: function ($event) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          $event.preventDefault();
          return false;
        }
      }
    },
  };
</script>
<style></style>